var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_815_88149",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(180 20.5 20)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_815_88149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3246 16.175L14.9496 12.55C14.9996 12.5 15.0371 12.4458 15.0621 12.3875C15.0871 12.3291 15.0996 12.2666 15.0996 12.2C15.0996 12.0666 15.0538 11.95 14.9621 11.85C14.8704 11.75 14.7496 11.7 14.5996 11.7H6.99961C6.84961 11.7 6.72878 11.75 6.63711 11.85C6.54544 11.95 6.49961 12.0666 6.49961 12.2C6.49961 12.2333 6.54961 12.35 6.64961 12.55L10.2746 16.175C10.3579 16.2583 10.4413 16.3166 10.5246 16.35C10.6079 16.3833 10.6996 16.4 10.7996 16.4C10.8996 16.4 10.9913 16.3833 11.0746 16.35C11.1579 16.3166 11.2413 16.2583 11.3246 16.175Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2746 3.22495L6.64961 6.84995C6.59961 6.89995 6.56211 6.95412 6.53711 7.01245C6.51211 7.07078 6.49961 7.13328 6.49961 7.19995C6.49961 7.33328 6.54544 7.44995 6.63711 7.54995C6.72878 7.64995 6.84961 7.69995 6.99961 7.69995H14.5996C14.7496 7.69995 14.8704 7.64995 14.9621 7.54995C15.0538 7.44995 15.0996 7.33328 15.0996 7.19995C15.0996 7.16662 15.0496 7.04995 14.9496 6.84995L11.3246 3.22495C11.2413 3.14162 11.1579 3.08328 11.0746 3.04995C10.9913 3.01662 10.8996 2.99995 10.7996 2.99995C10.6996 2.99995 10.6079 3.01662 10.5246 3.04995C10.4413 3.08328 10.3579 3.14162 10.2746 3.22495Z",
    fill: "#A3AED0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.94b34cc0fd2718522787a6495f41b89c.svg";
export { ForwardRef as ReactComponent };